// comments done

// taken from deck gl repo/docs
export const tooltipStyle = {
    position: 'absolute',
    padding: '8px',
    background: 'rgba(0, 0, 0, 0.9)',
    color: '#fff',
    maxWidth: '300px',
    fontSize: '16px',
    zIndex: 9,
    pointerEvents: 'none'
};

export const mapStylePicker = {
    background: '#fff',
    position: 'absolute',
    top: '20px',
    left: '20px',
    zIndex: 100
};

export const layerControl = {
    borderRadius: 3,
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
    fontFamily:
        'ff-clan-web-pro, "Helvetica Neue", Helvetica, sans-serif !important',
    fontSize: '12px',
    lineHeight: 1.833,
    width: 200,
    position: 'absolute',
    top: '20px',
    right: '20px',
    padding: '20px',
    zIndex: 100,
    background: 'white'
};

export const charts = {
    background: 'white',
    borderRadius: 3,
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
    fontFamily:
        'ff-clan-web-pro, "Helvetica Neue", Helvetica, sans-serif !important',
    fontSize: '12px',
    lineHeight: 1.833,
    height: 210,
    padding: '10px',
    position: 'absolute',
    left: 20,
    bottom: 20,
    width: 500,
    zIndex: 100
};

export const spinner = {
    animation: 'linear 2s infinite',
    background: '#1EACC7',
    borderRadius: '50%',
    height: 10,
    width: 10,
    opacity: 0.4,
    position: 'absolute',
    top: 70,
    left: 60,
    transformOrigin: '20px 20px',
    zIndex: 110
};
